import { ThreeViewBase, Config, stats3D, statsUtils } from "./index";
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';


/* Develop
 * 開発クラス.
 */
export class Develop {

	private _threeView: ThreeViewBase;
	private _gui: GUI;
	private _colorGui: GUI;
	private _placeGui: GUI;
	private _lightGui: GUI;
	private _environmentGui: GUI;
    private _serverCommandGui: GUI;

	// コンストラクタ
	constructor(threeView: ThreeViewBase) {
		this._threeView = threeView;
		this.addDevelopMenus();
	}

	public get threeViewBase(): ThreeViewBase { return this._threeView; }
	public get gui(): any { return this._gui; }
	public get ColorGui(): any { return this._colorGui; }
	public get PlaceGui(): any { return this._placeGui; }
	public get LightGui(): any { return this._lightGui; }
	public get EnvironmentGui_(): any { return this._environmentGui; }
    public get ServerCommandGUI(): GUI { return this._serverCommandGui; }

	public setupGui() {
		if (this._gui == undefined)
			// this._gui = new GUI.GUI();
			this._gui = new GUI();
	}
	public addGuiGroup(name: string): GUI {
		return this._gui.addFolder(name);
	}
	public setupColorGui() {
		if (this._colorGui == undefined)
			this._colorGui = new GUI();
	}
	public setupPlace() {
		if (this._placeGui == undefined)
			this._placeGui = new GUI();
	}
	public setupLight() {
		if (this._lightGui == undefined)
			this._lightGui = new GUI();
	}
	public setupEnvironment() {
		if (this._environmentGui == undefined)
			this._environmentGui = new GUI();
	}
    public setupServerCommand() {
        if (this._serverCommandGui == undefined) {
            this._serverCommandGui = new GUI();
        }
    }

	/* addDevelopMenu
	 * 開発メニュー追加.
	 */
	protected addDevelopMenus(): void {
		var scope = this._threeView;
		$("#developMenus3D").append('<input type="button" class="webcadBtn for3D dev3d" id="wireframe" value="wireframe" /> ');
		$('#wireframe').bind("click", function () {
			scope.scene.wireframe = !scope.scene.wireframe;
		});
		$("#developMenus3D").append('<input type="button" class="webcadBtn for3D dev3d" id="faceNormal" value="faceNorm" /> ');
		$("#developMenus3D").append('<input type="button" class="webcadBtn for3D dev3d" id="vertexNormal" value="vertexNorm" /> ');
		$('#vertexNormal').bind("click", function () {
			// scope.scene.vertexNormals = !scope.scene.vertexNormals;
		});
		$("#developMenus3D").append('<input type="button" class="webcadBtn for3D dev3d" id="stats" value="stats" /> ');
		$('#developMenus3D').append('<div id="statsResult" style="float:right"></div>');
		$('#stats').bind("click", function () {
			if ($('#statsResult').is(':empty')) {
				var stats: stats3D = statsUtils.getSceneStats(scope.scene);
				$('#statsResult').append('<label>-Scene Statistics-------------------</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nTotal) + '   objects' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nMeshes) + '   meshes' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nGeometries) + '   -geometries' + '</label><br/>');
				for (var i = 0; i < stats.geometryNames.length; i++)
					$('#statsResult').append('<label>' + "-->" + String(stats.geometryNames[i]) + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nBufferGeometries) + '   -bufferGeometries' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nUniqueBufferGeometries) + '    *uniqueBufferGeometries' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nPolygons) + '   polygons' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nVertices) + '   vertices' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nTextures) + '   textures' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nUniqueTextures) + '   *uniqueTextures' + '</label><br/>');
				for (var i = 0; i < stats.textureNames.length; i++)
					$('#statsResult').append('<label>' + "-->" + String(stats.textureNames[i]) + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nCubeTextures) + '   cubeTextures' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nUniqueCubeTextures) + '   *uniqueCubeTextures' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLights) + '   lights' + '</label><br/>');
				for (var i = 0; i < stats.lightNames.length; i++)
					$('#statsResult').append('<label>' + "-->" + String(stats.lightNames[i]) + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLightAmbients) + '   ambientLights' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLightDirectionals) + '   directionalLights' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLightPoints) + '   pointLights' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLightSpots) + '   spotLights' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nCameras) + '   cameras' + '</label><br/>');
				for (var i = 0; i < stats.cameraNames.length; i++)
					$('#statsResult').append('<label>' + "-->" + String(stats.cameraNames[i]) + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLines) + '   lines' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nLineSegments) + '   lineSegments' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nWebGLRenderer) + '   WebGLRenderers' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nGroups) + '   Groups' + '</label><br/>');
				$('#statsResult').append('<label>' + String(stats.nEmptyMeshes) + '   empty meshes' + '</label><br/>');
				for (var j = 0; j < stats.emptyMeshNames.length; j++)
					$('#statsResult').append('<label>' + "-->" + String(stats.emptyMeshNames[j]) + '</label><br/>');
			}
			else {
				$('#statsResult').empty();
			}
		});

		$('.for3D').hide();
		$('#developMenus3D').show();
	}
}
